import {Directive, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';

@Directive()
export class SafeSubscriberDirective implements OnDestroy {

  protected subs: Subscription[] = [];

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

}
